import React, { useState } from "react";
import reportTreasureFound from "./reportTreasureFound";

function TreasureInfoCard({ treasure, onClose, userId, onReportSuccess }) {
  const [showFoundForm, setShowFoundForm] = useState(false);
  const [comment, setComment] = useState("");
  const [photo, setPhoto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  if (!treasure) return null;

  const handleFoundClick = () => {
    setShowFoundForm(true);
    setSuccessMsg("");
    setErrorMsg("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");
    try {
      const result = await reportTreasureFound({
        treasureId: treasure.id,
        userId,
        comment,
        photo,
      });
      if (result.status === "success") {
        setSuccessMsg(""); // 不顯示本地成功訊息
        setShowFoundForm(false);
        setComment("");
        setPhoto(null);
        if (onReportSuccess) {
          onClose(); // 關閉 infocard
          setTimeout(() => {
            console.log("onReportSuccess called", result);
            onReportSuccess(result);
          }, 350); // 延遲顯示成功UI，確保 infocard 已消失
        }
      } else {
        setErrorMsg(result.error || "回報失敗，請稍後再試。");
      }
    } catch (err) {
      setErrorMsg("回報失敗，請檢查網路或稍後再試。");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        left: "50%",
        bottom: 120,
        transform: "translateX(-50%)",
        zIndex: 9999,
        background: "#fffbe6",
        border: "2px solid #c47f2b",
        borderRadius: 18,
        boxShadow: "0 6px 24px rgba(196,127,43,0.18)",
        padding: 24,
        minWidth: 260,
        maxWidth: 360,
        fontFamily: "Segoe UI",
        transition: "box-shadow 0.2s",
        opacity: 1,
        animation: "fadeInCard 0.18s cubic-bezier(.4,0,.2,1)",
        willChange: "opacity, transform",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
        <img
          src="/treasure.svg"
          alt="寶藏"
          style={{ width: 40, height: 40, marginRight: 12 }}
        />
        <span style={{ fontWeight: "bold", color: "#c47f2b", fontSize: 22 }}>
          寶藏資訊
        </span>
      </div>
      <div style={{ marginBottom: 10, color: "#23272f", fontSize: 17 }}>
        <span style={{ fontWeight: "bold" }}>描述：</span>{" "}
        {treasure.description || "無描述"}
      </div>
      <div style={{ marginBottom: 10, color: "#666", fontSize: 15 }}>
        <span style={{ fontWeight: "bold" }}>位置：</span>
        {Number(treasure.lat).toFixed(5)}, {Number(treasure.lng).toFixed(5)}
      </div>
      <div
        style={{
          marginBottom: 10,
          color: treasure.found ? "#888" : "#2b8c47",
          fontSize: 15,
        }}
      >
        <span style={{ fontWeight: "bold" }}>狀態：</span>
        {treasure.found ? "已被尋獲" : "尚未尋獲"}
      </div>
      {treasure.found_by && (
        <div style={{ marginBottom: 10, color: "#888", fontSize: 14 }}>
          <span style={{ fontWeight: "bold" }}>尋獲者：</span>{" "}
          {treasure.found_by}
        </div>
      )}
      {!treasure.found && !showFoundForm && (
        <button
          style={{
            marginTop: 12,
            background: "#2b8c47",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "10px 24px",
            fontWeight: "bold",
            fontSize: 16,
            cursor: "pointer",
            boxShadow: "0 2px 8px #2b8c4722",
          }}
          onClick={handleFoundClick}
        >
          尋獲寶藏
        </button>
      )}
      {showFoundForm && (
        <form onSubmit={handleSubmit} style={{ marginTop: 16 }}>
          <div style={{ marginBottom: 10 }}>
            <label style={{ fontWeight: "bold", color: "#c47f2b" }}>
              留言：
              <input
                type="text"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{
                  marginLeft: 8,
                  padding: "6px 10px",
                  borderRadius: 6,
                  border: "1px solid #c47f2b",
                  width: "70%",
                  fontSize: 15,
                }}
                placeholder="分享你的發現..."
                required
              />
            </label>
          </div>
          <div style={{ marginBottom: 10 }}>
            <label style={{ fontWeight: "bold", color: "#c47f2b" }}>
              上傳照片：
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setPhoto(e.target.files[0])}
                style={{ marginLeft: 8 }}
              />
            </label>
          </div>
          <button
            type="submit"
            style={{
              background: "#c47f2b",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "8px 20px",
              fontWeight: "bold",
              fontSize: 15,
              cursor: "pointer",
              boxShadow: "0 2px 6px #c47f2b22",
            }}
            disabled={loading}
          >
            {loading ? "提交中..." : "提交"}
          </button>
          {errorMsg && (
            <div style={{ color: "#d32f2f", marginTop: 8 }}>{errorMsg}</div>
          )}
          {successMsg && (
            <div style={{ color: "#2b8c47", marginTop: 8 }}>{successMsg}</div>
          )}
        </form>
      )}
      <button
        style={{
          marginTop: 12,
          background: "#c47f2b",
          color: "#fff",
          border: "none",
          borderRadius: 10,
          padding: "10px 24px",
          fontWeight: "bold",
          fontSize: 16,
          cursor: "pointer",
          boxShadow: "0 2px 8px #c47f2b22",
        }}
        onClick={onClose}
      >
        關閉
      </button>
      <style>{`
        @keyframes fadeInCard {
          0% { opacity: 0; transform: translateY(12px) scale(0.98); }
          60% { opacity: 1; transform: translateY(-2px) scale(1.01); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>
  );
}

export default TreasureInfoCard;
